/** Two-letter monogram: first letters of the first two words, or the first two letters of one word. */
export function initialsFrom(label: string, fallback = 'GS'): string {
  const parts = label.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return fallback;
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return `${parts[0]![0] ?? ''}${parts[1]![0] ?? ''}`.toUpperCase();
}
